import config from "../config/config";
import { KEY_sessionLanguage } from "../constants";
import { loadPageContentsAsync } from "../reduxToolkit/features/contentSlice";
import store from "../reduxToolkit/store";
import { isSupportedLanguage } from "../services/languageUtils";
import { readFromStorage } from "../services/storageServies";
import { loadGetCareNowDetails, loadHealthBlog } from "../services/contentService";
import { LogVerbose } from "../services/logUtils";

// START: GitHub Copilot Generated Code
// Run startup content preloading as soon as this module is evaluated.
// This is imported as a side effect from index.tsx to start as early as possible.
const getLanguageFromQueryString = (): string | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }

  const languageParam =
    new URL(window.location.href).searchParams.get("lang") ||
    new URL(window.location.href).searchParams.get("language");
  if (!languageParam) {
    return undefined;
  }

  return languageParam.split("-")[0]?.trim().toLowerCase();
};

const resolveStartupLanguage = (): string => {
  const languageFromQuery = getLanguageFromQueryString();
  if (languageFromQuery && isSupportedLanguage(languageFromQuery)) {
    return languageFromQuery;
  }

  const sessionLanguage = readFromStorage<string>(KEY_sessionLanguage, "SessionStorage");
  if (sessionLanguage && isSupportedLanguage(sessionLanguage)) {
    return sessionLanguage;
  }

  return config.languageConfig.defaultLanguageName;
};

const preloadStartupContent = async () => {
  LogVerbose("Starting startup content preload");
  const language = resolveStartupLanguage();

  LogVerbose(`Startup preload: loading page contents for language: ${language}`);
  await store.dispatch(loadPageContentsAsync(language));

  LogVerbose(`Startup preload: loading GetCareNow and Health Blog in background for language: ${language}`);
  void Promise.allSettled([
    loadGetCareNowDetails(language),
    loadHealthBlog(language),
  ]).then((results) => {
    results.forEach((result, index) => {
      if (result.status === "rejected") {
        const target = index === 0 ? "GetCareNow" : "Health Blog";
        console.error(`Startup preload failed for ${target} (${language})`, result.reason);
      }
    });
  });
};

void preloadStartupContent();
// END: GitHub Copilot Generated Code
